var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { method: "GET", action: "/de/search", id: "search-form" },
      on: {
        submit: function($event) {
          return _vm.search()
        }
      }
    },
    [
      _c("input", {
        ref: "searchInput",
        staticClass: "search-input",
        attrs: {
          name: "query",
          type: "search",
          id: "flAutocompleteInputText",
          placeholder: "Möbel suchen...",
          minlength: "2",
          onclick: "loadFindologic()"
        },
        on: {
          keyup: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              return _vm.keydown()
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              return _vm.keyup()
            }
          ],
          focus: function($event) {
            _vm.isSearchFocused = true
          },
          blur: function($event) {
            return _vm.onBlurSearchField($event)
          }
        }
      }),
      _vm._v(" "),
      _vm._t("search-button", [
        _c(
          "button",
          {
            staticClass: "search-submit btn-search",
            attrs: { type: "submit" },
            on: {
              click: function($event) {
                return _vm.search()
              }
            }
          },
          [_c("i", { staticClass: "fa fa-search sm-up" })]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }